import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import axios from 'axios'
import './i18n'
import { setDefaults } from 'react-geocode'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { store } from './reducers'
import './scss/index.scss'
import { initTracking } from './utils/posthog'

// Init posthog tracking
initTracking()

setDefaults({
  key: process.env.REACT_APP_GM_KEY,
  region: 'us',
})

console.log('v1.7.14')
axios.interceptors.request.use(
  (config) => {
    const updatedConfig = { ...config }
    const token = localStorage.getItem('token')
    return {
      ...updatedConfig,
      headers: {
        ...updatedConfig.headers,
        Authorization: token ? `Bearer ${token}` : '',
      },
    }
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  },
)
const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
